import React,{useState} from 'react'
import { useNavigate } from 'react-router-dom'
import './Nav.css'
import { useContext } from 'react'
import { navigatorOpenContext } from '../../appContext'

function Nav() {
    const { navigatorOpen, setNavigatorOpen } = useContext(navigatorOpenContext)
    const Navigate = useNavigate()
    const [menuBar,setMenuBar] = useState(false)
    return (
        <div className={navigatorOpen ? 'navigator navigator-open' : 'navigator'}>
            <div className="nav-container">
                <h1>Muhammed Habeeb kv</h1>
                <span className='menu' onClick={() => {
                    if(menuBar){
                        setMenuBar(false)
                    }
                    else{
                        setMenuBar(true)
                    }
                }}><i className="fa fa-bars" aria-hidden="true"></i></span>
                {
                 menuBar?<div className="menu-container">
                 <ul>
                     <li onClick={() => Navigate('/')}>Home
                     </li>
                     <li onClick={() => {
                         Navigate('/project')
                         setNavigatorOpen(false)
                     }}>Portfolio
                     </li>
                     <li onClick={() => {
                         Navigate('/about')
                         setNavigatorOpen(false)
                     }}>About
                     </li>
                 </ul>
                 </div>:null
                }
            </div>
        </div>
    )
}

export default Nav
